module.exports = __webpack_public_path__ + "fontawesome-webfont.ttf?b06871f281fee6b241d60582ae9369b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 913
// module chunks = 27